// Configuración de WhatsApp para pedidos

/**
 * Número de WhatsApp del negocio
 * 
 * Formato: código de país + número sin espacios, guiones ni paréntesis
 * 
 * Ejemplos:
 * - Chile: '56912345678' (56 + 9 + número de 8 dígitos)
 * - Argentina: '5491123456789' (54 + 9 + código de área + número)
 * - México: '5215512345678' (52 + 1 + código de área + número)
 * 
 * IMPORTANTE: Asegúrate de que el número esté correcto y tenga WhatsApp activo
 */
export const WHATSAPP_BUSINESS_NUMBER = '56945613334';

/**
 * Nombre del negocio para los mensajes
 */
export const BUSINESS_NAME = 'El Piñón Minimarket';

/**
 * Horario de atención (opcional, para mostrar en el mensaje)
 */
export const BUSINESS_HOURS = 'Lun-Sáb: 9:00-21:00, Dom: 10:00-20:00';
